// src/customer-filter/customer-filter-schema.ts
import { oz as oz17 } from "@vy/oz";

// src/customer-filter/customer-filter-schemas/customer-status-filter-schema.ts
import { oz } from "@vy/oz";
import { EnumFilterInputSchema } from "@vy/query-specifications-types";
import { CUSTOMER_STATUSES } from "@vy/types";

// src/customer-filter/customer-filterable-fields.ts
var CUSTOMER_FILTERABLE_FIELDS = Object.freeze({
  STATUS: "status",
  NAME: "name",
  REVENUE: "revenue",
  CREATED_AT: "createdAt",
  UPDATED_AT: "updatedAt",
  PARENT_CUSTOMER: "parentCustomer",
  SUBSIDIARY: "subsidiary",
  ADDRESS: "address",
  COUNTRY: "country",
  STATE: "state",
  CITY: "city",
  POSTAL_CODE: "postalCode",
  MANUAL_REVIEW: "manualReview",
  LABELS: "labelIds",
  TAX_ID: "taxIds",
  WALLET: "wallet",
  ALIASES: "aliases"
});

// src/customer-filter/customer-filter-schemas/customer-status-filter-schema.ts
var CustomerStatusFieldPathSchema = oz.literal(CUSTOMER_FILTERABLE_FIELDS.STATUS);
var CustomerStatusFilterSchema = EnumFilterInputSchema.extend({
  field: CustomerStatusFieldPathSchema,
  value: oz.union([oz.nativeEnum(CUSTOMER_STATUSES), oz.array(oz.nativeEnum(CUSTOMER_STATUSES))])
}).openapi("CustomerStatusfilter");

// src/customer-filter/customer-filter-schemas/customer-name-filter-schema.ts
import { oz as oz2 } from "@vy/oz";
import { StringFilterInputSchema } from "@vy/query-specifications-types";
var CustomerNameFieldPathSchema = oz2.literal(CUSTOMER_FILTERABLE_FIELDS.NAME);
var CustomerNameValueSchema = oz2.union([oz2.string(), oz2.array(oz2.string())]);
var CustomerNameFilterSchema = StringFilterInputSchema.extend({
  field: CustomerNameFieldPathSchema,
  value: CustomerNameValueSchema
}).openapi("CustomerNameFilter");

// src/customer-filter/customer-filter-schemas/customer-revenue-filter-schema.ts
import { oz as oz3 } from "@vy/oz";
import { NumberFilterInputSchema } from "@vy/query-specifications-types";
var CustomerRevenueFieldPathSchema = oz3.literal(CUSTOMER_FILTERABLE_FIELDS.REVENUE);
var CustomerRevenueValueSchema = oz3.union([oz3.number(), oz3.array(oz3.number())]);
var CustomerRevenueFilterSchema = NumberFilterInputSchema.extend({
  field: CustomerRevenueFieldPathSchema,
  value: CustomerRevenueValueSchema
}).openapi("CustomerRevenueFilter");

// src/customer-filter/customer-filter-schemas/customer-parent-customer-filter-schema.ts
import { oz as oz4 } from "@vy/oz";
import { StringFilterInputSchema as StringFilterInputSchema2 } from "@vy/query-specifications-types";
var CUSTOMER_FILTERS = Object.freeze({
  PARENT: "parent",
  CHILD: "child"
});
var CustomerParentCustomerFieldPathSchema = oz4.literal(
  CUSTOMER_FILTERABLE_FIELDS.PARENT_CUSTOMER
);
var CustomerParentCustomerValueSchema = oz4.union([oz4.string(), oz4.array(oz4.string())]);
var CustomerParentCustomerFilterSchema = StringFilterInputSchema2.extend({
  field: CustomerParentCustomerFieldPathSchema,
  value: CustomerParentCustomerValueSchema
}).openapi("CustomerParentCustomerFilter");

// src/customer-filter/customer-filter-schemas/customer-subsidiary-filter-schema.ts
import { oz as oz5 } from "@vy/oz";
import { StringFilterInputSchema as StringFilterInputSchema3 } from "@vy/query-specifications-types";
var CustomerSubsidiaryFieldPathSchema = oz5.literal(CUSTOMER_FILTERABLE_FIELDS.SUBSIDIARY);
var CustomerSubsidiaryValueSchema = oz5.union([oz5.string(), oz5.array(oz5.string())]);
var CustomerSubsidiaryFilterSchema = StringFilterInputSchema3.extend({
  field: CustomerSubsidiaryFieldPathSchema,
  value: CustomerSubsidiaryValueSchema
}).openapi("CustomerSubsidiaryFilter");

// src/customer-filter/customer-filter-schemas/customer-address-filter-schema.ts
import { oz as oz6 } from "@vy/oz";
import { StringFilterInputSchema as StringFilterInputSchema4 } from "@vy/query-specifications-types";
var CustomerAddressFieldPathSchema = oz6.literal(CUSTOMER_FILTERABLE_FIELDS.ADDRESS);
var CustomerAddressValueSchema = oz6.union([oz6.string(), oz6.array(oz6.string())]);
var CustomerAddressFilterSchema = StringFilterInputSchema4.extend({
  field: CustomerAddressFieldPathSchema,
  value: CustomerAddressValueSchema
}).openapi("CustomerAddressFilter");

// src/customer-filter/customer-filter-schemas/customer-country-filter-schema.ts
import { oz as oz7 } from "@vy/oz";
import { StringFilterInputSchema as StringFilterInputSchema5 } from "@vy/query-specifications-types";
var CustomerCountryFieldPathSchema = oz7.literal(CUSTOMER_FILTERABLE_FIELDS.COUNTRY);
var CustomerCountryValueSchema = oz7.union([oz7.string(), oz7.array(oz7.string())]);
var CustomerCountryFilterSchema = StringFilterInputSchema5.extend({
  field: CustomerCountryFieldPathSchema,
  value: CustomerCountryValueSchema
}).openapi("CustomerCountryFilter");

// src/customer-filter/customer-filter-schemas/customer-state-filter-schema.ts
import { oz as oz8 } from "@vy/oz";
import { StringFilterInputSchema as StringFilterInputSchema6 } from "@vy/query-specifications-types";
var CustomerStateFieldPathSchema = oz8.literal(CUSTOMER_FILTERABLE_FIELDS.STATE);
var CustomerStateValueSchema = oz8.union([oz8.string(), oz8.array(oz8.string())]);
var CustomerStateFilterSchema = StringFilterInputSchema6.extend({
  field: CustomerStateFieldPathSchema,
  value: CustomerStateValueSchema
}).openapi("CustomerStateFilter");

// src/customer-filter/customer-filter-schemas/customer-city-filter-schema.ts
import { oz as oz9 } from "@vy/oz";
import { StringFilterInputSchema as StringFilterInputSchema7 } from "@vy/query-specifications-types";
var CustomerCityFieldPathSchema = oz9.literal(CUSTOMER_FILTERABLE_FIELDS.CITY);
var CustomerCityValueSchema = oz9.union([oz9.string(), oz9.array(oz9.string())]);
var CustomerCityFilterSchema = StringFilterInputSchema7.extend({
  field: CustomerCityFieldPathSchema,
  value: CustomerCityValueSchema
}).openapi("CustomerCityFilter");

// src/customer-filter/customer-filter-schemas/customer-postal-code-filter-schema.ts
import { oz as oz10 } from "@vy/oz";
import { StringFilterInputSchema as StringFilterInputSchema8 } from "@vy/query-specifications-types";
var CustomerPostalCodeFieldPathSchema = oz10.literal(CUSTOMER_FILTERABLE_FIELDS.POSTAL_CODE);
var CustomerPostalCodeValueSchema = oz10.union([oz10.string(), oz10.array(oz10.string())]);
var CustomerPostalCodeFilterSchema = StringFilterInputSchema8.extend({
  field: CustomerPostalCodeFieldPathSchema,
  value: CustomerPostalCodeValueSchema
}).openapi("CustomerPostalCodeFilter");

// src/customer-filter/customer-filter-schemas/customer-manual-review-filter-schema.ts
import { oz as oz11 } from "@vy/oz";
import { BooleanFilterInputSchema } from "@vy/query-specifications-types";
var CustomerManualReviewFieldPathSchema = oz11.literal(CUSTOMER_FILTERABLE_FIELDS.MANUAL_REVIEW);
var CustomerManualReviewValueSchema = oz11.union([oz11.boolean(), oz11.array(oz11.boolean())]);
var CustomerManualReviewFilterSchema = BooleanFilterInputSchema.extend({
  field: CustomerManualReviewFieldPathSchema,
  value: CustomerManualReviewValueSchema
}).openapi("CustomerManualReviewFilter");

// src/customer-filter/customer-filter-schemas/customer-labels-filter-schema.ts
import { ArrayFilterInputSchema } from "@vy/query-specifications-types";
import { oz as oz12 } from "@vy/oz";
var CustomerLabelsFieldPathSchema = oz12.literal(CUSTOMER_FILTERABLE_FIELDS.LABELS);
var CustomerLabelsFilterSchema = ArrayFilterInputSchema.extend({
  field: CustomerLabelsFieldPathSchema,
  value: oz12.array(oz12.string())
}).openapi("CustomerLabelsFilter");

// src/customer-filter/customer-filter-schemas/customer-custom-field-filter-schema.ts
import { EnumFilterInputSchema as EnumFilterInputSchema2, NumberFilterInputSchema as NumberFilterInputSchema2, StringFilterInputSchema as StringFilterInputSchema9, BooleanFilterInputSchema as BooleanFilterInputSchema2 } from "@vy/query-specifications-types";
import { oz as oz13 } from "@vy/oz";
var CUSTOMER_CUSTOM_FIELD_PREFIX = "customFieldValues.";
var CustomerCustomFieldFieldPathSchema = oz13.string().startsWith(CUSTOMER_CUSTOM_FIELD_PREFIX).openapi("CustomerCustomFieldFieldPath");
var CustomerCustomFieldEnumFilterSchema = EnumFilterInputSchema2.extend({
  field: CustomerCustomFieldFieldPathSchema,
  value: oz13.array(oz13.string())
});
var CustomerCustomFieldStringFilterSchema = StringFilterInputSchema9.extend({
  field: CustomerCustomFieldFieldPathSchema
});
var CustomerCustomFieldNumberFilterSchema = NumberFilterInputSchema2.extend({
  field: CustomerCustomFieldFieldPathSchema,
  value: oz13.union([oz13.number(), oz13.array(oz13.number())])
});
var CustomerCustomFieldBooleanFilterSchema = BooleanFilterInputSchema2.extend({
  field: CustomerCustomFieldFieldPathSchema,
  value: oz13.union([oz13.boolean(), oz13.array(oz13.boolean())])
});
var CustomerCustomFieldFilterSchema = oz13.union([
  CustomerCustomFieldEnumFilterSchema,
  CustomerCustomFieldStringFilterSchema,
  CustomerCustomFieldNumberFilterSchema,
  CustomerCustomFieldBooleanFilterSchema
]).openapi("CustomerCustomFieldFilter");

// src/customer-filter/customer-filter-schemas/customer-tax-id-filter-schema.ts
import { oz as oz14 } from "@vy/oz";
import { StringFilterInputSchema as StringFilterInputSchema10 } from "@vy/query-specifications-types";
var CustomerTaxIdFieldPathSchema = oz14.literal(CUSTOMER_FILTERABLE_FIELDS.TAX_ID);
var CustomerTaxIdValueSchema = oz14.union([oz14.string(), oz14.array(oz14.string())]);
var CustomerTaxIdFilterSchema = StringFilterInputSchema10.extend({
  field: CustomerTaxIdFieldPathSchema,
  value: CustomerTaxIdValueSchema
}).openapi("CustomerTaxIdFilter");

// src/customer-filter/customer-filter-schemas/customer-wallet-filter-schema.ts
import { oz as oz15 } from "@vy/oz";
import { StringFilterInputSchema as StringFilterInputSchema11 } from "@vy/query-specifications-types";
var CustomerWalletFieldPathSchema = oz15.literal(CUSTOMER_FILTERABLE_FIELDS.WALLET);
var CustomerWalletValueSchema = oz15.union([oz15.string(), oz15.array(oz15.string())]);
var CustomerWalletFilterSchema = StringFilterInputSchema11.extend({
  field: CustomerWalletFieldPathSchema,
  value: CustomerWalletValueSchema
}).openapi("CustomerWalletFilter");

// src/customer-filter/customer-filter-schemas/customer-aliases-filter-schema.ts
import { oz as oz16 } from "@vy/oz";
import { StringFilterInputSchema as StringFilterInputSchema12 } from "@vy/query-specifications-types";
var CustomerAliasesFieldPathSchema = oz16.literal(CUSTOMER_FILTERABLE_FIELDS.ALIASES);
var CustomerAliasesValueSchema = oz16.union([oz16.string(), oz16.array(oz16.string())]);
var CustomerAliasesFilterSchema = StringFilterInputSchema12.extend({
  field: CustomerAliasesFieldPathSchema,
  value: CustomerAliasesValueSchema
}).openapi("CustomerAliasesFilter");

// src/customer-filter/customer-filter-schema.ts
var CustomerFilterSchema = oz17.union([
  CustomerStatusFilterSchema,
  CustomerNameFilterSchema,
  CustomerRevenueFilterSchema,
  CustomerParentCustomerFilterSchema,
  CustomerSubsidiaryFilterSchema,
  CustomerAddressFilterSchema,
  CustomerCountryFilterSchema,
  CustomerStateFilterSchema,
  CustomerCityFilterSchema,
  CustomerPostalCodeFilterSchema,
  CustomerManualReviewFilterSchema,
  CustomerLabelsFilterSchema,
  CustomerCustomFieldFilterSchema,
  CustomerTaxIdFilterSchema,
  CustomerWalletFilterSchema,
  CustomerAliasesFilterSchema
]).openapi("CustomerFilterNew");

// src/customer/customer.ts
import {
  CustomerSchema,
  OVERAGE_SETTINGS,
  CustomerIntegrationEntitySchema,
  BaseIntegrationEntitySchema,
  CrmIntermediateMetadataSchema,
  CRM_INTEGRATION_PROVIDERS,
  ERP_INTEGRATION_PROVIDERS,
  PAYMENT_INTEGRATION_PROVIDERS,
  CONTRACT_STATUSES
} from "@vy/types";

// src/customer-overview/customer-overview-columns-keys.ts
var CUSTOMERS_COLUMNS_KEYS = Object.freeze({
  STATUS: "status",
  NAME: "name",
  LABELS: "labels",
  ACCRUED: "contractsCount",
  CREATED_AT: "createdAt",
  UPDATED_AT: "updatedAt",
  PARENT_CUSTOMER: "parentCustomer",
  SUBSIDIARY: "subsidiary",
  ADDRESS: "address",
  COUNTRY: "country",
  STATE: "state",
  CITY: "city",
  POSTAL_CODE: "postalCode",
  PAYMENT_DUE_DAYS: "paymentDueDays",
  MANUAL_REVIEW: "manualReview",
  LEGAL_NAME: "legalName",
  CRM_ID: "crmId",
  ERP_ID: "erpId",
  TAX_ID: "taxIds",
  TAX_TYPE: "taxRate",
  WALLET: "wallet",
  ALIASES: "aliases"
});
export {
  BaseIntegrationEntitySchema,
  CONTRACT_STATUSES,
  CRM_INTEGRATION_PROVIDERS,
  CUSTOMERS_COLUMNS_KEYS,
  CUSTOMER_CUSTOM_FIELD_PREFIX,
  CUSTOMER_FILTERABLE_FIELDS,
  CUSTOMER_FILTERS,
  CrmIntermediateMetadataSchema,
  CustomerAddressFieldPathSchema,
  CustomerAddressFilterSchema,
  CustomerAliasesFieldPathSchema,
  CustomerAliasesFilterSchema,
  CustomerCityFieldPathSchema,
  CustomerCityFilterSchema,
  CustomerCountryFieldPathSchema,
  CustomerCountryFilterSchema,
  CustomerCustomFieldFieldPathSchema,
  CustomerCustomFieldFilterSchema,
  CustomerFilterSchema,
  CustomerIntegrationEntitySchema,
  CustomerLabelsFieldPathSchema,
  CustomerLabelsFilterSchema,
  CustomerManualReviewFieldPathSchema,
  CustomerManualReviewFilterSchema,
  CustomerNameFieldPathSchema,
  CustomerNameFilterSchema,
  CustomerParentCustomerFieldPathSchema,
  CustomerParentCustomerFilterSchema,
  CustomerPostalCodeFieldPathSchema,
  CustomerPostalCodeFilterSchema,
  CustomerRevenueFieldPathSchema,
  CustomerRevenueFilterSchema,
  CustomerSchema,
  CustomerStateFieldPathSchema,
  CustomerStateFilterSchema,
  CustomerStatusFieldPathSchema,
  CustomerStatusFilterSchema,
  CustomerSubsidiaryFieldPathSchema,
  CustomerSubsidiaryFilterSchema,
  CustomerTaxIdFieldPathSchema,
  CustomerTaxIdFilterSchema,
  CustomerWalletFieldPathSchema,
  CustomerWalletFilterSchema,
  ERP_INTEGRATION_PROVIDERS,
  OVERAGE_SETTINGS,
  PAYMENT_INTEGRATION_PROVIDERS
};
